// src/pages/PostView.jsx

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { API_BASE } from "../api/api";
import PostCard from "../components/PostCard";

const PostView = () => {
  const { id } = useParams();

const navigate = useNavigate();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchPost = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${API_BASE}/api/posts/${id}`);

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();

      console.log("Fetched post:", data);

      

      setPost(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [id]);


useEffect(() => {
  const token = localStorage.getItem("token");

  if (!token) {
    navigate(
      `/register?redirect=${encodeURIComponent(`/post/${id}`)}`,
      { replace: true }
    );
    return;
  }

  fetchPost();
}, [fetchPost, id, navigate]);

  
  const rawImage = post?.media?.[0]?.url;

  const image = rawImage
    ? rawImage.startsWith("http")
      ? rawImage
      : `https://africsocial.com${rawImage}`
    : "https://africsocial.com/social-preview.png";

  const title = post?.user?.name
    ? `${post.user.name}: ${post.content?.substring(0, 60) || ""}`
    : "Someone shared a post";

  const description =
    post?.content?.substring(0, 160) ||
    "Check this post on AfricSocial";

  const url = `https://africsocia.com/post/${post?._id || ""}`;

  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  if (error) {
    return (
      <div className="p-4 text-red-500">
        Error: {error}
      </div>
    );
  }

  if (!post) {
    return (
      <div className="p-4">
        Post not found.
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta
          name="description"
          content={description}
        />

        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="AfricSocial" />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content={title}
        />
        <meta
          name="twitter:description"
          content={description}
        />
        <meta
          name="twitter:image"
          content={image}
        />
      </Helmet>

      <div className="max-w-2xl mx-auto p-3">
        <PostCard post={post} />
      </div>
    </>
  );
};

export default PostView;